import type { FacetTableData } from "./facet-table-helpers";

export type FacetTablePersistTarget = "result" | "normalization";

function rowsUseMatrixShape(existingRows: unknown): boolean {
    return Array.isArray(existingRows) && existingRows.some((row) => Array.isArray(row));
}

export function applyFacetTableEditsToResult(
    existingResult: Record<string, unknown>,
    table: FacetTableData
): Record<string, unknown> {
    const out: Record<string, unknown> = { ...existingResult };
    if (rowsUseMatrixShape(existingResult.rows)) {
        out.rows = table.rows.map((row) => table.headers.map((header) => row[header] ?? ""));
        return out;
    }
    out.rows = table.rows.map((row) => ({ ...row }));
    return out;
}

export function applyFacetTableEditsToFacetResult(
    facetResult: Record<string, unknown>,
    table: FacetTableData,
    target: FacetTablePersistTarget
): Record<string, unknown> {
    if (target === "normalization") {
        const existing = facetResult.normalization_result;
        const normalizationResult =
            existing != null && typeof existing === "object" && !Array.isArray(existing)
                ? (existing as Record<string, unknown>)
                : {};
        return {
            ...facetResult,
            normalization_result: applyFacetTableEditsToResult(normalizationResult, table),
        };
    }
    return applyFacetTableEditsToResult(facetResult, table);
}
